module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0006-min.d1142002.jpg";